module.exports = __webpack_public_path__ + "static/media/user_5.1598dbb0.png";